import { ids } from "@icarros/theme-react";
import styled from "styled-components";
const { spacing } = ids || {};
export const Wrapper = styled.label `
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: ${spacing.ids_spacing_8x};
`;
export const StyledInput = styled.input `
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
`;
export const StyledReactIconSingle = styled.div `
  display: flex;
  align-items: center;
  cursor: pointer;
  width: fit-content;
  cursor: ${({ isDisabled, isError }) => isDisabled || isError ? "unset" : "pointer"};
  position: relative;
`;
//# sourceMappingURL=ReactIcon.style.js.map